import React from "react";
import { Store } from "../../../Affiliate/utils/STORE";
import { ThemeProvider } from "@semcore/utils/lib/ThemeProvider";
import { Plot, Donut } from "@semcore/ui/d3-chart";
import { Flex } from "@semcore/ui/flex-box";
import { Text } from "@semcore/ui/typography";
import { useTranslation } from "react-i18next";

const PieChartForRank = () => {
  const { RankUpPercent } = Store((state) => state);
  const { t } = useTranslation();

  const data = {
    a: RankUpPercent?.noRank?.length,
    b: RankUpPercent?.top3?.length,
    c: RankUpPercent?.top10?.length,
    d: RankUpPercent?.top100?.length,
  };

  const dataKeyName = {
    a: t("dashboard.data_key_name.no_rank"),
    b: t("dashboard.data_key_name.top_3"),
    c: t("dashboard.data_key_name.top_10"),
    d: t("dashboard.data_key_name.top_100"),
  };

  const grayPrimaryControlTheme = {
    "--intergalactic-chart-palette-order-1": "#E95655",
    "--intergalactic-chart-palette-order-2": "#3BA1C5",
    "--intergalactic-chart-palette-order-3": "#365486",
    "--intergalactic-chart-palette-order-4": "#F3A344",
    "--intergalactic-control-primary-info": "#6c6e79",
    "--intergalactic-control-primary-info-hover": "#484a54",
    "--intergalactic-control-primary-info-active": "#2b2e38",
  };

  return (
    <ThemeProvider tokens={grayPrimaryControlTheme}>
      <Flex
        flexWrap
        gap={"20px"}
        alignItems="flex-start"
        justifyContent="center"
      >
        <Plot width={180} height={180} data={data}>
          <Donut innerRadius={50}>
            <Donut.EmptyData />
            {Object.keys(data).map((name) => (
              <Donut.Pie key={name} dataKey={name} name={dataKeyName[name]} />
            ))}
          </Donut>
          <Donut.Tooltip>
            {({ dataKey, name }) => {
              return {
                children: (
                  <>
                    <Donut.Tooltip.Title>{name}</Donut.Tooltip.Title>
                    <Flex justifyContent="space-between">
                      <Text bold>{data[dataKey]}</Text>
                    </Flex>
                  </>
                ),
              };
            }}
          </Donut.Tooltip>
        </Plot>
        <Flex direction="column">
          {Object.keys(data).map((name) => {
            return (
              <Flex justifyContent="space-between" key={dataKeyName[name]}>
                <Text size={300}>{dataKeyName[name]} </Text>
                <Text className="ms-3" size={300}>
                  {data[name]}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </ThemeProvider>
  );
};

export default PieChartForRank;
